// src/App.js
import React from 'react';
import './App.css';
import Login from './Pages/Login';
import Register from './Pages/Register';
import Dashboard from './Pages/Dashboard';
import DoctorProfile from './Pages/DoctorProfile';
import DoctorSchedule from './Pages/DoctorSchedule';
import DoctorRequest from './Pages/DoctorRequest';
import CreateDoctorSchedule  from './Pages/CreateDoctorSchedule';
import DoctorSchedulelist from './Pages/DoctorSchedulelist'; 
import EditDoctorSchedule from './Pages/EditDoctorSchedule'; 
import DoctorProfileEdit from './Pages/DoctorProfileEdit';
import DoctorProfileInfoEdit from './Pages/DoctorProfileInfoEdit';
import Register_Doctor from './Pages/Register_Doctor';
import Forgotpassword from './Pages/Forgotpassword';
import DoctorScheduleupdate from './Pages/DoctorScheduleupdate';
// import Forgotpassword from './Pages/Forgotpassword';
// import Forgotpassword from './Pages/Forgotpassword';
// import Forgotpassword from './Pages/Forgotpassword';
// import Forgotpassword from './Pages/Forgotpassword';

import DoctorAppointment from './Pages/DoctorAppointment';
import Incoming from "./Pages/incoming";


import { Routes, Route, Navigate } from 'react-router-dom';
import FinanceDetail from './Pages/FinanceDetail';
// import ProtectedRoute from './ProtectedRoute'; // Ensure the path is correct
// import { AuthProvider } from './AuthContext'; // Import the AuthProvider

function App() {
  return (

    <Routes>
    <Route path="/" element={<Login />} />
    <Route path="/Register" element={<Register />} />
    <Route path="/Dashboard/:id" element={<Dashboard />} />
    <Route path="/Register_Doctor" element={<Register_Doctor />} />
    <Route path="/Forgotpassword" element={<Forgotpassword />} />
    
    {/* <Route path="/Register_Doctor" element={<Register_Doctor />} />
    <Route path="/Register_Doctor" element={<Register_Doctor />} />
    <Route path="/Register_Doctor" element={<Register_Doctor />} /> */}
    <Route path="/DoctorScheduleupdate" element={<DoctorScheduleupdate />} />

    {/* Doctor Route */}
    <Route path="/CreateDoctorSchedule/:id" element={<CreateDoctorSchedule />} />
    <Route path="/DoctorProfile/:id" element={<DoctorProfile />} />
    <Route path="/DoctorSchedule/:id" element={<DoctorSchedule />} />
    <Route path="/DoctorAppointment/:id" element={<DoctorAppointment />} />
    <Route path="/EditDoctorSchedule/:id" element={<EditDoctorSchedule />} />
    <Route path="/DoctorProfileEdit/:id" element={<DoctorProfileEdit />} />
    <Route path="/DoctorProfileInfoEdit/:id" element={<DoctorProfileInfoEdit />} />
    <Route path="/DoctorScheduleupdate/:id" element={<DoctorScheduleupdate />} />
    <Route path="/FinanceDetail/:id" element={<FinanceDetail />} />

    {/* Admin Route */}
    <Route path="/DoctorSchedulelist" element={<DoctorSchedulelist />} />    
    <Route path="/DoctorRequest" element={<DoctorRequest />} />
    
    <Route path="*" element={<Navigate to="/" />} /> {/* Fallback route */}

    <Route path="/incoming" element={<Incoming />} />
  </Routes>


    // <AuthProvider>
    //   <Routes>
    //     <Route path="/" element={<Login />} />
    //     {/* <Route path="/Register" element={<Register />} /> */}

    //     <Route path="/Register" element={<Register />} />
    //     <Route path="/DoctorSchedulelist" element={<DoctorSchedulelist />} />
    //     <Route path="/CreateDoctorSchedule" element={<CreateDoctorSchedule />} />
    //     <Route path="/DoctorSchedulelist" element={<DoctorSchedulelist />} />
    //     <Route path="/DoctorProfile/:id" element={<DoctorProfile />} />
    //     <Route path="/DoctorSchedule/:id" element={<DoctorSchedule />} />


    //     <Route path="/Dashboard" element={<Dashboard />} />
    //     <Route path="/DoctorRequest" element={<DoctorRequest />} />
        
    //             {/* Doctor Route */}
    //     {/* <Route path="/DoctorProfile/:id" element={<ProtectedRoute allowedRoles={['Employee Doctor']}><DoctorProfile /></ProtectedRoute>} />
    //     <Route path="/CreateDoctorSchedule" element={<ProtectedRoute allowedRoles={['Employee Doctor']}><CreateDoctorSchedule /></ProtectedRoute>} />
    //     <Route path="/DoctorSchedule/:id" element={<ProtectedRoute allowedRoles={['Employee Doctor']}><DoctorSchedule /></ProtectedRoute>} />
    //      */}

    //     {/* Admin Route */}
    //     {/* <Route path="/Dashboard" element={<ProtectedRoute allowedRoles={['Administrator']}><Dashboard /></ProtectedRoute>} />
    //     <Route path="/DoctorRequest" element={<ProtectedRoute allowedRoles={['Administrator']}><DoctorRequest /></ProtectedRoute>} />
    //     <Route path="/DoctorSchedulelist" element={<ProtectedRoute allowedRoles={['Administrator']}><DoctorSchedulelist  /></ProtectedRoute>} /> */}

    //     <Route path="*" element={<Navigate to="/" />} /> {/* Fallback route */}
    //   </Routes>
    // </AuthProvider>
  );
}

export default App;


